import logoIcon from 'assets/images/img_thaco_inductries_logo.png';

const common = {
  logo: logoIcon
};

export default common;
